import { render, staticRenderFns } from "./Presentacion.vue?vue&type=template&id=996e1804&scoped=true"
import script from "./Presentacion.vue?vue&type=script&lang=js"
export * from "./Presentacion.vue?vue&type=script&lang=js"
import style0 from "./Presentacion.vue?vue&type=style&index=0&id=996e1804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996e1804",
  null
  
)

export default component.exports